document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.nyxi-faq-wrap').forEach(function (wrap) {
    var paragraphs = wrap.querySelectorAll('p');
    var items = [];
    var currentQ = null;
    var currentA = [];

    paragraphs.forEach(function (p) {
      var strong = p.querySelector('strong');
      if (strong && strong.textContent.trim() === p.textContent.trim()) {
        if (currentQ) items.push({ q: currentQ, a: currentA.join('') });
        currentQ = strong.textContent.trim();
        currentA = [];
      } else if (currentQ) {
        currentA.push('<p>' + p.innerHTML + '</p>');
      }
    });
    if (currentQ) items.push({ q: currentQ, a: currentA.join('') });

    if (items.length > 0) {
      var html = items.map(function (item) {
        return '<details class="nyxi-faq-item">'
          + '<summary class="nyxi-faq-question"><span>' + item.q + '</span><span class="nyxi-faq-arrow"></span></summary>'
          + '<div class="nyxi-faq-answer">' + item.a + '</div>'
          + '</details>';
      }).join('');
      wrap.innerHTML = html;

      // Close others when one opens
      wrap.querySelectorAll('details.nyxi-faq-item').forEach(function (det) {
        det.addEventListener('toggle', function () {
          if (det.open) {
            wrap.querySelectorAll('details.nyxi-faq-item').forEach(function (other) {
              if (other !== det) other.open = false;
            });
          }
        });
      });
    }
  });
});
